module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-room-customers"
  }, [_c('div', {
    staticClass: "with-actions"
  }, [_c('h2', [_vm._v("房客信息")]), _c('div', {
    staticClass: "ui buttons actions hide-in-mobile"
  }, [_c('div', {
    staticClass: "ui basic icon button",
    on: {
      "click": function($event) {
        _vm.dialog_customers_visible = true
      }
    }
  }, [_c('i', {
    staticClass: "icon pencil themed text"
  })])])]), _c('auto-edit-table', {
    attrs: {
      "defines": _vm.$defines.customer,
      "unstackable": "unstackable",
      "data": _vm.customers,
      "button-add": false,
      "actions": _vm.get_customer_actions
    },
    on: {
      "action:card_checkin": _vm.native_invoke_checkin,
      "action:right:card_checkin": function (c) { return _vm.form_add_card(c); },
      "action:card_extension": _vm.native_invoke_extension,
      "action:card_supplement": _vm.native_invoke_supplement,
      "action:card_checkout": _vm.native_invoke_checkout,
      "action:kitchen_new": _vm.native_invoke_kitchen_new,
      "action:right:card_checkout": function (c) { return _vm.form_remove_card(c); }
    }
  }), _c('dialog-customers', {
    attrs: {
      "visible": _vm.dialog_customers_visible,
      "contract": _vm.contract
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_customers_visible = $event
      },
      "exit": _vm.customer_dialog_exit
    }
  }), _c('promise-dialog', {
    ref: "dialog_making",
    attrs: {
      "title": "发卡中..."
    }
  }, [_c('p', [_vm._v("请等待系统完成发卡操作")])]), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog_idcard_verify,
      "title": _vm.dialog_idcard_verify_title
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_idcard_verify = $event
      }
    }
  }, [_c('p', [_vm._v("请将身份证放置于身份证读卡器上")]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.dialog_idcard_verify_cancel
    }
  }, [_vm._v("取消")]), (_vm.$permission.has("native.cards.skip_vertify")) ? _c('div', {
    staticClass: "ui button orange",
    on: {
      "click": _vm.dialog_idcard_verify_skip
    }
  }, [_vm._v("跳过验证")]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a21a763a","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormRoomCustomers.vue
// module id = 407
// module chunks = 0